import { render, staticRenderFns } from "./WechatQrcodeLayer.vue?vue&type=template&id=012f7f34&scoped=true"
import script from "./WechatQrcodeLayer.vue?vue&type=script&lang=js"
export * from "./WechatQrcodeLayer.vue?vue&type=script&lang=js"
import style0 from "./WechatQrcodeLayer.vue?vue&type=style&index=0&id=012f7f34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f7f34",
  null
  
)

export default component.exports